// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"963":"8be9ec9b","984":"ad39fd2a"}[chunkId] + ".chunk.js";
};